import React from 'react';
import styled, { keyframes } from 'styled-components';
import { withRouter } from 'react-router';
import withStore from 'with-store';
import oh from 'output-helpers';
import userInputs from 'user-inputs';
import api_helpers from '../../helpers/api_helpers';
import * as order_helpers from '../../helpers/order_helpers';
import Navbar from '../base/Navbar';
import Button from '../base/Button';
import EntityListItem from '../base/EntityListItem';
import TaskListItem from '../base/TaskListItem';
import OrganizationListItem from '../base/OrganizationListItem';
import GuideCard from '../base/GuideCard';
import { FaPlus, FaSearch, FaTrash } from 'react-icons/fa';
import { FaExclamation, MdClear } from 'react-icons/all';
import StarRatingComponent from 'react-star-rating-component';
import default_config from '../../default_config';

class CreateView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            render_custom_presentation: true,
            search_focus: false,
            search_term: '',
            selected_category: 0,
            associated_orgs: [],
            vehicles: [],
            location: {
                coords: [],
                address: '',
            },
            invoice_info: '',
            tasks: [],
            priority: 0,
            starColor: '#32CD32',
        };

        let schema = this.props.store.entity.schema.vehicles;

        this.vehicle_types = [].concat(
            schema.by_id['meta.vehicle_type'].alternatives,
        );
        this.vehicle_types.sort();

        this.input_invoice_info = userInputs.generateForm([
            {
                onChange: e => {
                    this.setState({ invoice_info: e });
                },
                placeholder: oh.translate('invoice_info'),
                default_value: this.state.invoice_info,
                key: 'invoice_info',
                type: 'textarea',
                label: oh.translate('invoice_info'),
                value: this.state.invoice_info,
            },
        ]);

        this.new_location = userInputs.generateForm([
            {
                onChange: value => {
                    let location = this.state.location;
                    location.address = value;
                    this.setState({
                        location,
                    });
                },
                placeholder: oh.translate('enter_location'),
                default_value: this.state.location.address,
                type: 'text',
                key: 'address',
                label: oh.translate('enter_address'),
                value: this.state.location.address,
            },
        ]);

        this.switchCategoryActions = () => {
            this.new_location.setInputConfig({
                key: 'address',
                default_value: this.state.location.address,
            });
            this.input_invoice_info.setInputConfig({
                key: 'invoice_info',
                default_value: this.state.invoice_info,
            });
        };

        this.categories = [
            {
                name: 'where',
                layout: 'layout_full',
                onClick: () => {
                    this.setState({
                        selected_category: 0,
                        render_custom_presentation: true,
                    });
                    this.switchCategoryActions();
                },
                listItemClick: () => {
                    // render_custom_presentation

                    return (
                        <div className="">
                            <GuideCard
                                image={'where'}
                                withForm
                                title={oh.translate('create_where_title')}
                                bread={oh.translate(
                                    'create_edit_location_subtitle',
                                )}
                            >
                                <div className="mock_form">
                                    <this.new_location.component />
                                    {oh.translate('map') +
                                        ' ' +
                                        oh.translate(
                                            'not_implemented_in_test_version',
                                            false,
                                        ) +
                                        '.'}
                                </div>
                            </GuideCard>
                        </div>
                    );
                },
                addNewItemLabel: oh.translate('add_new_location'),
                getItems: (state, props) => {
                    return false;
                },
                addNewItem: term => {
                    /*this.setState({
                        location: {
                            coords: [56,12],
                            address: this.state.search_term
                        },
                        selected_location: true,
                        search_focus: false,
                        search_term: ""
                    });*/
                },
                getSearchableItems: (state, props) => {
                    let searchable = [];
                    return searchable;
                },
                addButton: false,
            },
            {
                name: 'entities',
                onClick: () => {
                    // Click navbar step
                    this.setState({ selected_category: 1 });
                    this.switchCategoryActions();
                },
                getItems: (state, props) => {
                    return state.vehicles;
                },
                getSearchableItems: (state, props) => {
                    let searchable = [];
                    props.se.getVehicles().forEach(vehicle => {
                        if (
                            state.vehicles.some(
                                selected_vehicle =>
                                    selected_vehicle.id === vehicle.id,
                            ) === false
                        ) {
                            searchable.push({
                                ...vehicle,
                                extra_search_parameter: `${
                                    vehicle.data['meta.vehicle_number']
                                        ? vehicle.data['meta.vehicle_number']
                                        : ''
                                }`,
                            });
                        }
                    });
                    searchable.sort((a, b) => {
                        return a.name.toLowerCase() < b.name.toLowerCase()
                            ? -1
                            : 1;
                    });
                    return searchable;
                },
                listItemClick: () => {
                    this.setState({
                        render_custom_presentation: false,
                    });
                },
                addSearchItem: item => {
                    let selected_vehicles = [].concat(
                        this.state.vehicles,
                        item,
                    );
                    selected_vehicles.sort((a, b) => {
                        return a.name.toLowerCase() < b.name.toLowerCase()
                            ? -1
                            : 1;
                    });
                    this.setState({
                        vehicles: selected_vehicles,
                        search_term: '',
                        search_focus: false,
                    });
                },
                addNewItemLabel: oh.translate('add_new_vehicle'),
                addNewItem: term => {
                    this.triggerAddEntity();
                },
                addButton: () => {
                    this.triggerAddEntity();
                },
            },
            {
                name: 'what',
                searchable_items: false,
                onClick: () => {
                    this.setState({
                        selected_category: 2,
                        render_custom_presentation: false,
                    });
                    this.switchCategoryActions();
                },
                getItems: (state, props) => {
                    return state.tasks;
                },
                getSearchableItems: (state, props) => {
                    return null;
                },
                addNewItemLabel: oh.translate('create_manually'),
                addNewItem: term => {
                    this.setState({
                        render_custom_presentation: true,
                        search_term: '',
                        search_focus: false,
                    });
                },
                addButton: () => {
                    this.setState({
                        render_custom_presentation: true,
                    });
                },
                listItemClick: () => {
                    return (
                        <GuideCard
                            withForm
                            title={oh.translate('create_add_task')}
                            bread={oh.translate('describe_task')}
                        >
                            <div className="mock_form">
                                <this.new_task.component />
                            </div>
                        </GuideCard>
                    );
                },
            },
            {
                name: 'who',
                onClick: () => {
                    this.setState({ selected_category: 3 });
                    this.switchCategoryActions();
                },
                getItems: (state, props) => {
                    return state.associated_orgs;
                },
                getSearchableItems: (state, props) => {
                    let searchable = [];
                    props.se.getOrgs().forEach(org => {
                        if (
                            state.associated_orgs.some(
                                selected_org => selected_org.id === org.id,
                            ) === false
                        ) {
                            searchable.push({ id: org.id, name: org.name });
                        }
                    });
                    return searchable;
                },
                addNewItem: false,
                addSearchItem: item => {
                    let buff = this.state.associated_orgs;
                    buff.push(item);
                    this.setState({
                        associated_orgs: buff,
                        search_term: '',
                        search_focus: false,
                    });
                },
                addButton: false,
            },
            {
                name: 'summary',
                layout: 'layout_full',
                onClick: () => {
                    this.setState({
                        selected_category: 4,
                        render_custom_presentation: true,
                    });
                    this.switchCategoryActions();
                },
                listItemClick: () => {
                    let disable_submit =
                        this.state.vehicles.length === 0 ||
                        this.state.tasks.length === 0 ||
                        this.state.associated_orgs.length === 0;
                    return (
                        <GuideCard
                            withForm
                            image={'summary'}
                            title={oh.translate('create_summary_title')}
                            bread={oh.translate('create_summary_bread')}
                        >
                            <div className="mock_form">
                                <div className="mock_form_half_width">
                                    <this.input_invoice_info.component />
                                </div>
                                <p className="mock_form_label">
                                    {oh.translate('entities')}
                                </p>
                                {this.renderListOfType(
                                    'entities',
                                    this.state.vehicles,
                                    true,
                                    false,
                                )}
                                <br />
                                <p className="mock_form_label">
                                    {oh.translate('tasks')}
                                </p>
                                {this.renderListOfType(
                                    'what',
                                    this.state.tasks,
                                    true,
                                    false,
                                )}
                                <br />
                                <p className="mock_form_label">
                                    {oh.translate('add_who')}
                                </p>
                                {this.renderListOfType(
                                    'who',
                                    this.state.associated_orgs,
                                    true,
                                    false,
                                )}
                                <br />
                                <p className="mock_form_label">
                                    {oh.translate('where')}
                                </p>
                                <p className="mock_form_empty_label">
                                    {this.state.location.address.length > 0
                                        ? this.state.location.address
                                        : oh.translate('no_location')}
                                </p>
                                <br />
                                <p className={'mock_form_label'}>
                                    {oh.translate('priority')}
                                </p>
                                <br />
                                {/*{ @TODO fix sizing?*/}
                                <StarRatingComponent
                                    name={'priority'}
                                    starCount={3}
                                    onStarClick={nextValue => {
                                        this.setState({
                                            priority: nextValue,
                                            starColor:
                                                default_config.star_color[
                                                    nextValue - 1
                                                ],
                                        });
                                    }}
                                    starColor={this.state.starColor}
                                    value={this.state.priority}
                                    renderStarIcon={() => <FaExclamation />}
                                />
                                <MdClear
                                    onClick={() =>
                                        this.setState({ priority: 0 })
                                    }
                                />
                                <Button
                                    filled
                                    block
                                    disabled={disable_submit}
                                    label={
                                        disable_submit
                                            ? oh.translate(
                                                  'incomplete_create_order_wizard',
                                              )
                                            : oh.translate('place_order')
                                    }
                                    onClick={() => {
                                        const order = {
                                            associated_orgs: this.state
                                                .associated_orgs,
                                            data: {},
                                        };
                                        if (
                                            this.state.location.coords
                                                .length === 2
                                        ) {
                                            order.location = this.state.location.coords;
                                        }
                                        if (this.state.location.address) {
                                            order.data.address = this.state.location.address;
                                        }
                                        if (this.state.invoice_info) {
                                            order.data.invoice_info = this.state.invoice_info;
                                        }
                                        if (this.state.priority) {
                                            order.data.priority = this.state.priority;
                                        }
                                        order_helpers
                                            .createOrder(
                                                this.state.vehicles,
                                                this.state.tasks,
                                                order,
                                            )
                                            .then(result => {
                                                let { order, tasks } = result;
                                                this.props.actions.order.setOrder(
                                                    order,
                                                );
                                                this.props.actions.tasks.setTasks(
                                                    tasks,
                                                );
                                                this.props.history.push('/');
                                            });
                                    }}
                                />
                            </div>
                        </GuideCard>
                    );
                },
                getItems: (state, props) => {
                    return null;
                },
                getSearchableItems: (state, props) => {
                    return null;
                },
                addButton: () => {
                    console.log('no add');
                },
            },
        ];

        const anim_slide_up = keyframes`
            from {
                transform: translateY(100%);
            }
            to {
                transform: none;
            }
        `;

        const anim_slide_right = keyframes`
            from {
                transform: translateX(-100%);
            }
            to {
                transform: none;
            }
        `;

        const anim_fade_in = keyframes`
            from {
                opacity: 0;
            }
            to {
                opacity: 1;
            }
        `;

        const anim_slide_down = keyframes`
            from {
                opacity: 0;
                transform: translateY(-10%);
            }
            to {
                opacity: 1;
                transform: none;
            }
        `;

        this.container = styled.div`
            height: 100vw;

            .mock_form_empty_label {
                font-size: 14px;
                opacity: 0.7;
                font-style: italic;
            }
            .mock_form {
                animation: ${anim_slide_right} 0.8s;
                padding: 20px 0;
                margin-bottom: 100px;
                .mock_form_half_width {
                    width: 50%;
                }
                .mock_form_label {
                    font-size: 14px;
                    font-weight: bold;
                    margin-bottom: 6px;
                }
                .user_input {
                    margin-bottom: 12px;
                }
                button {
                    background-color: ${props => props.theme.colors.blue[1]};
                    border-color: ${props => props.theme.colors.blue[1]};
                    color: #fff;
                    margin: 12px 0;
                    &:hover {
                        border-color: ${props => props.theme.colors.blue[2]};
                    }
                }
                ul {
                    li {
                        border: 1px solid ${props => props.theme.colors.border};
                    }
                }
            }
            .search_fade {
                position: fixed;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background-color: rgba(128, 142, 163, 0.48);
                display: none;
                z-index: 2;
                &.active {
                    display: block;
                    animation: ${anim_fade_in} 0.5s;
                }
            }
            .dashboard_layout {
                overflow: auto;
                position: absolute;
                top: 110px;
                bottom: 0;
                left: 0;
                right: 0;
                display: grid;
                grid-column-gap: 2%;
                grid-template-columns: calc(98% - 400px) 400px;
                padding: 30px 30px 100px;
                &.layout_full {
                    grid-template-columns: 100%;
                }
                .dashboard_ctr {
                    height: 300px;
                    background-color: rgba(0, 0, 0, 0.2);
                }
                .dashboard_presentation {
                    height: 300px;
                    background-color: rgba(0, 0, 0, 0.2);
                    ul {
                        width: 100%;
                        li {
                            background-color: #fff;
                            width: 100%;
                            padding: 10px;
                        }
                    }
                }
            }
            .view_fixed_footer {
                animation: ${anim_slide_up} 0.8s;
                background-color: #fff;
                box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.1);
                position: fixed;
                bottom: 0;
                left: 0;
                right: 0;
                padding: 16px 30px;
                .view_fixed_footer_left,
                .view_fixed_footer_right {
                    display: inline-block;
                    width: 50%;
                    button {
                        margin-right: 20px;
                        &:last-child {
                            margin-right: 0;
                        }
                    }
                }
                .view_fixed_footer_right {
                    text-align: right;
                }
            }
            .dashboard_list_search {
                border-radius: 20px;
                background-color: #fff;
                padding: 6px 8px;
                margin-bottom: 8px;
                position: relative;
                z-index: 3;
                .search_icon {
                    position: absolute;
                    top: 11px;
                    left: 12px;
                }
                input {
                    padding: 4px 4px 4px 28px;
                    width: 100%;
                    font-size: 15px;
                    border: 0;
                    &:focus {
                        & + svg {
                            fill: ${props => props.theme.colors.blue[2]};
                        }
                    }
                }
                .search_result {
                    animation: ${anim_slide_down} 0.4s;
                    position: absolute;
                    width: 100%;
                    left: 0;
                    top: 42px;
                    ul.search_result_list {
                        max-height: 270px;
                        overflow: auto;
                        li {
                            padding: 0;
                            cursor: pointer;
                            &:hover {
                                border-color: ${props =>
                                    props.theme.colors.blue[0]};
                                background-color: ${props =>
                                    props.theme.colors.blue[1]};
                                color: #fff;
                                .search_result_remove {
                                    border-color: #fff;
                                }
                            }
                            .highlight {
                                background-color: #fdf474;
                            }
                            .search_result_name,
                            .search_result_remove,
                            .search_result_extra_search_parameter {
                                display: inline-block;
                                vertical-align: middle;
                            }
                            .search_result_name {
                                padding: 10px 20px;
                                width: 75%;
                            }
                            .search_result_extra_search_parameter {
                                width: 25%;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                padding: 10px;
                                font-size: 12px;
                                opacity: 0.6;
                            }
                            .search_result_remove {
                                padding: 0 12px;
                                border-left: 1px solid
                                    ${props => props.theme.colors.border};
                                width: 25%;
                                text-align: center;
                            }
                        }
                    }
                }
            }
            .dashboard_list_button {
                border: none;
                cursor: pointer;
                color: #fff;
                font-size: 16px;
                padding: 0;
                background-color: ${props => props.theme.colors.blue[2]};
                height: 34px;
                width: 34px;
                border-radius: 4px;
                line-height: 0px;
                svg {
                    vertical-align: middle;
                }
                &:hover {
                    background-color: ${props => props.theme.colors.blue[1]};
                }
            }
            .dashboard_list {
                .dashboard_list_head {
                    font-size: 16px;
                    border-radius: 4px;
                    background-color: ${props => props.theme.colors.dark[1]};
                    color: #fff;
                    margin-bottom: 8px;
                    font-weight: bold;
                    .dashboard_list_head_left,
                    .dashboard_list_head_right {
                        display: inline-block;
                        vertical-align: middle;
                    }
                    .dashboard_list_head_left {
                        padding: 14px 20px;
                        width: 70%;
                    }
                    .dashboard_list_head_right {
                        text-align: right;
                        width: 30%;
                        padding: 0 5px;
                    }
                }
                ul {
                    border-radius: 4px;
                    border: 1px solid ${props => props.theme.colors.border};
                    background-color: #fff;
                    li {
                        font-size: 14px;
                        border-bottom: 1px solid
                            ${props => props.theme.colors.border};
                        &:first-child {
                            border-top-left-radius: 4px;
                            border-top-right-radius: 4px;
                        }
                        &:last-child {
                            border-bottom: none;
                            border-bottom-left-radius: 4px;
                            border-bottom-right-radius: 4px;
                        }
                        .dashboard_list_item_name,
                        .dashboard_list_item_remove {
                            display: inline-block;
                            vertical-align: middle;
                        }
                        .dashboard_list_item_name {
                            width: 80%;
                            padding: 14px 20px;
                        }
                        .dashboard_list_item_remove {
                            padding: 0 12px;
                            border-left: 1px solid
                                ${props => props.theme.colors.border};
                            width: 20%;
                            text-align: center;
                        }
                    }
                }
            }
            .empty_search {
                text-align: center;
                .empty_search_message {
                    padding: 40px 20px;
                    .empty_search_message_term {
                        padding: 4px;
                        margin-top: 10px;
                        border-radius: 4px;
                        background-color: rgb(242, 242, 242);
                    }
                }
                .empty_search_action {
                    padding: 0 20px 20px;
                }
            }
        `;

        this.triggerAddTag = () => {
            let confirmCB = values => {
                let new_tag = values.new_tag_name.trim();
                if (new_tag.length === 0) {
                    console.log('Tried to create empty tag.');
                    //TODO: Show message.
                    return;
                }
                let lowercase_tag = new_tag.toLowerCase();
                if (
                    this.props.store.tags.all.some(
                        tag => tag.name.toLowerCase() === lowercase_tag,
                    )
                ) {
                    //The tag already exists.
                    console.log('Tried to create existing tag.');
                    //TODO: Show message.
                    return;
                }
                api_helpers
                    .addTag(values.new_tag_name)
                    .then(tag_from_server => {
                        let current_tags_value = this.new_task
                            .getForms()[0]
                            .getValues().tags;
                        this.props.actions.tags.addTag(tag_from_server);
                        const new_options = this.props.store.tags.all.map(
                            tag => {
                                return { label: tag.name, value: tag.id };
                            },
                        );
                        new_options.sort((a, b) => {
                            return a.label.toLowerCase() < b.label.toLowerCase()
                                ? -1
                                : 1;
                        });
                        // const new_option = { label: tag_from_server.name, value: tag_from_server.id };
                        this.new_task.setInputConfig({
                            key: 'tags',
                            value: [].concat(
                                current_tags_value,
                                tag_from_server.id,
                            ),
                            options: new_options,
                        });
                    });
            };
            this.props.userPrompt.confirm(
                {
                    inputs: [
                        {
                            type: 'text',
                            key: 'new_tag_name',
                            label: oh.translate('enter_new_tag'),
                            default_value: '',
                        },
                    ],
                },
                confirmCB,
            );
        };

        this.new_task = userInputs.generateForm(
            [
                {
                    type: 'select',
                    key: 'type',
                    label: oh.translate('task_type'),
                    default_value: 'device-repair',
                    options: [
                        {
                            label: oh.translate('device-repair'),
                            value: 'device-repair',
                        },
                        {
                            label: oh.translate('device-install'),
                            value: 'device-install',
                        },
                        { label: oh.translate('misc'), value: 'misc' },
                    ],
                },
                {
                    type: 'multi_select',
                    key: 'tags',
                    label: oh.translate('task_tags'),
                    placeholder: oh.translate('add_existing') + '...',
                    default_value: [],
                    searchable: true,
                    no_options_message: oh.translate('no_search_results'),
                    options: this.props.store.tags.all
                        .map(tag => {
                            return { label: tag.name, value: tag.id };
                        })
                        .sort((a, b) => {
                            return a.label.toLowerCase() < b.label.toLowerCase()
                                ? -1
                                : 1;
                        }),
                },
                {
                    type: 'button',
                    label: oh.translate('new_tag'),
                    props: {
                        onClick: () => {
                            this.triggerAddTag();
                        },
                    },
                },
                {
                    type: 'textarea',
                    key: 'desc',
                    label: oh.translate('task_description'),
                    default_value: '',
                },
                {
                    type: 'confirm',
                    label: oh.translate('task_save'),
                    props: {},
                },
            ],
            values => {
                let new_task = {
                    type: values.type,
                    tags: values.tags,
                    data: {
                        description: values.desc,
                    },
                };
                let buff = this.state.tasks;
                buff.push(new_task);
                this.setState({
                    tasks: buff,
                    render_custom_presentation: false,
                });
            },
        );
    }

    triggerAddEntity() {
        let schema = this.props.store.entity.schema.vehicles;
        let depot_alts = schema.by_id['meta.depot'].alternatives;

        let inputs = [
            {
                type: 'text',
                key: 'id_reg',
                label: oh.translate('id_reg'),
                default_value: this.state.search_term,
            },
            {
                type: 'select',
                key: 'depot',
                options: depot_alts.map(opt => {
                    return { value: opt, label: opt };
                }),
                label: oh.translate('depot'),
                default_value: depot_alts[0],
            },
            {
                type: 'text',
                key: 'jlt_vehicle_number',
                label: oh.translate('jlt_vehicle_number'),
                default_value: '',
            },
            {
                type: 'text',
                key: 'vin',
                label: oh.translate('vin_number'),
                default_value: '',
            },
            {
                type: 'select',
                key: 'type',
                label: oh.translate('vehicle_type'),
                default_value: this.vehicle_types[0],
                options: this.vehicle_types.map(type => {
                    return { value: type, label: type };
                }),
            },
        ];
        let prompt_props = {
            title: oh.translate('add_new_vehicle'),
        };
        let confirmCallback = values => {
            let id_reg = values.id_reg;
            if (id_reg.length < 1) {
                console.log('Tried to add vehicle without id_reg.');
                //TODO: Show message.
                return;
            }
            let encoded_id = 'entity://vehicles/' + encodeURIComponent(id_reg);
            if (this.props.store.entity.by_id.hasOwnProperty(encoded_id)) {
                //This id already exists.
                if (
                    this.state.vehicles.some(
                        selected_vehicle => selected_vehicle.id === encoded_id,
                    )
                ) {
                    //TODO: Show message.
                    return;
                }
                //Add it to selected list.
                let vehicle_entity = this.props.store.entity.by_id[encoded_id];
                this.setState({
                    vehicles: [].concat(this.state.vehicles, vehicle_entity),
                    search_term: '',
                    search_focus: false,
                });
            } else {
                let vehicle = {
                    'meta.id': id_reg.toUpperCase().replace(/ /g, ''),
                };

                if (values.depot) {
                    vehicle['meta.depot'] = values.depot;
                }
                if (values.jlt_vehicle_number.length !== 0) {
                    vehicle['meta.vehicle_number'] = parseInt(
                        values.jlt_vehicle_number,
                        10,
                    );
                }
                if (values.type) {
                    vehicle['meta.vehicle_type'] = values.type;
                }
                if (values.vin) {
                    vehicle['meta.vin'] = values.vin;
                }

                api_helpers
                    .createEntity('vehicles', {
                        id: id_reg.toUpperCase().replace(/ /g, ''),
                        data: vehicle,
                    })
                    .then(vehicle_entity => {
                        this.props.actions.entity.setEntity(
                            'vehicle',
                            vehicle_entity,
                        );
                        this.setState({
                            vehicles: [].concat(
                                this.state.vehicles,
                                vehicle_entity,
                            ),
                            search_term: '',
                            search_focus: false,
                        });
                    });
            }
        };
        this.props.userPrompt.confirm(
            {
                inputs: inputs,
                props: prompt_props,
                confirm_button_label: oh.translate('yes'),
                cancel_button_label: oh.translate('no'),
            },
            confirmCallback,
        );
    }

    leaveView(doc) {
        let inputs = [];
        let prompt_props = {
            title: oh.translate('are_you_sure'),
            message: oh.translate('confirm_leave_view'),
            confirm_button_label: oh.translate('yes'),
            cancel_button_label: oh.translate('no'),
        };
        let leaveCallback = values => {
            this.props.history.push('/');
        };
        this.props.userPrompt.confirm(
            {
                inputs: inputs,
                props: prompt_props,
            },
            leaveCallback,
        );
    }

    renderStepContent() {
        if (
            this.state.render_custom_presentation !== false &&
            this.categories[this.state.selected_category].listItemClick
        ) {
            return this.categories[
                this.state.selected_category
            ].listItemClick();
        }

        return (
            <GuideCard
                image={this.categories[this.state.selected_category].name}
                title={oh.translate(
                    'create_' +
                        this.categories[this.state.selected_category].name +
                        '_title',
                )}
                subtitle={oh.translate(
                    'create_' +
                        this.categories[this.state.selected_category].name +
                        '_subtitle',
                )}
                bread={oh.translate(
                    'create_' +
                        this.categories[this.state.selected_category].name +
                        '_bread',
                )}
            />
        );
    }

    renderListOfType(type, items, small = false, trash = true) {
        if (items.length > 0) {
            return (
                <ul>
                    {items.map((item, i) => {
                        if (type === 'entities') {
                            let option = null;
                            if (trash) {
                                option = {
                                    icon: 'trash',
                                    onClick: () => {
                                        let vehicles = [].concat(
                                            this.state.vehicles,
                                        );
                                        vehicles.splice(i, 1);
                                        this.setState({
                                            vehicles: vehicles,
                                        });
                                    },
                                };
                            }
                            return (
                                <EntityListItem
                                    small={small}
                                    key={i}
                                    entity={item}
                                    onClickItem={() => {
                                        this.props.se.setSelectedEntity(
                                            item.id,
                                        );
                                    }}
                                    option={option}
                                />
                            );
                        }

                        if (type === 'what') {
                            let removeCB = undefined;
                            if (trash) {
                                removeCB = () => {
                                    this.setState({
                                        tasks: this.state.tasks.filter(
                                            x => x !== item,
                                        ),
                                    });
                                };
                            }
                            let resolved_tags = item.tags.map(
                                tag_id => this.props.store.tags.by_id[tag_id],
                            );
                            return (
                                <TaskListItem
                                    small={small}
                                    key={i}
                                    task={{
                                        ...item,
                                        type: oh.translate(item.type),
                                        tags: resolved_tags,
                                    }}
                                    onClickItem={() => {
                                        console.log(
                                            'not possible not edit tasks yet',
                                        );
                                        /*
                                            this.setState({ render_custom_presentation: true });
                                            */
                                    }}
                                    onClickRemove={removeCB}
                                />
                            );
                        }

                        if (type === 'who') {
                            let removeCB = undefined;
                            if (trash) {
                                removeCB = () => {
                                    let selected_orgs = [].concat(
                                        this.state.associated_orgs,
                                    );
                                    selected_orgs.splice(i, 1);
                                    this.setState({
                                        associated_orgs: selected_orgs,
                                    });
                                };
                            }
                            return (
                                <OrganizationListItem
                                    small={small}
                                    key={i}
                                    organization={item}
                                    onClickItem={() => {
                                        this.setState({
                                            render_custom_presentation: true,
                                        });
                                    }}
                                    onClickRemove={removeCB}
                                />
                            );
                        }

                        return (
                            <li key={i} onClick={() => {}}>
                                <div
                                    className="dashboard_list_item_name"
                                    onClick={() => {
                                        this.setState({
                                            render_custom_presentation: true,
                                        });
                                    }}
                                >
                                    {item.name}
                                </div>
                                <div className="dashboard_list_item_remove">
                                    <FaTrash />
                                </div>
                            </li>
                        );
                    })}
                </ul>
            );
        }

        return (
            <p className="mock_form_empty_label">
                {oh.translate('none_added_to_list')}
            </p>
        );
    }
    // @TODO
    renderListedItems() {
        // The whole right section of the view
        if (
            this.state.selected_category < 0 ||
            !this.categories[this.state.selected_category].getItems(
                this.state,
                this.props,
            )
        ) {
            return null;
        }
        return (
            <div className="dashboard_list">
                <div className="dashboard_list_head">
                    <div className="dashboard_list_head_left">
                        <p>
                            {oh.translate(
                                'add_' +
                                    this.categories[
                                        this.state.selected_category
                                    ].name,
                            )}
                        </p>
                    </div>
                    {this.categories[this.state.selected_category].addButton ===
                    false ? null : (
                        <div className="dashboard_list_head_right">
                            <button
                                className="dashboard_list_button"
                                onClick={() =>
                                    this.categories[
                                        this.state.selected_category
                                    ].addButton()
                                }
                            >
                                <FaPlus />
                            </button>
                        </div>
                    )}
                </div>
                {this.renderSearch()}
                {this.renderListOfType(
                    this.categories[this.state.selected_category].name,
                    this.categories[this.state.selected_category].getItems(
                        this.state,
                        this.props,
                    ),
                )}
            </div>
        );
    }

    renderSearch() {
        if (
            this.categories[this.state.selected_category].searchable_items ===
            false
        ) {
            return null;
        }

        let search_options = this.categories[
            this.state.selected_category
        ].getSearchableItems(this.state, this.props);

        let search_result = [];
        let object_search_string = '';
        if (this.state.search_term.length > 0) {
            search_options.forEach(item => {
                object_search_string = item.name.toLowerCase();
                if (item.hasOwnProperty('extra_search_parameter')) {
                    object_search_string += ` ${item.extra_search_parameter.toLowerCase()}`;
                }
                if (
                    object_search_string.includes(
                        this.state.search_term.toLowerCase(),
                    )
                ) {
                    search_result.push(item);
                }
            });
        } else {
            search_result = search_options;
        }

        const highlight = highlightTerm => {
            const index = highlightTerm
                .toLowerCase()
                .indexOf(this.state.search_term.toLowerCase());
            if (index === -1) {
                return <p>{highlightTerm}</p>;
            }
            return (
                <p>
                    {highlightTerm.substring(0, index)}
                    <span className="highlight">
                        {highlightTerm.substring(
                            index,
                            index + this.state.search_term.length,
                        )}
                    </span>
                    {highlightTerm.substring(
                        index + this.state.search_term.length,
                    )}
                </p>
            );
        };

        return (
            <div className="dashboard_list_search">
                <input
                    placeholder={oh.translate('search')}
                    value={this.state.search_term
                        .replace(/ /g, '')
                        .toUpperCase()}
                    onFocus={() => this.setState({ search_focus: true })}
                    onChange={e => {
                        this.setState({ search_term: e.target.value });
                    }}
                />
                <FaSearch className="search_icon" />

                {this.state.search_term.length > 0 ||
                this.state.search_focus ? (
                    <div className="search_result">
                        <ul className="search_result_list">
                            {search_result.length > 0 ? (
                                search_result.map((item, i) => {
                                    return (
                                        <li
                                            key={i}
                                            onClick={() => {
                                                this.categories[
                                                    this.state.selected_category
                                                ].addSearchItem(item);
                                            }}
                                        >
                                            <div className="search_result_name">
                                                {highlight(item.name)}
                                            </div>
                                            {item.hasOwnProperty(
                                                'extra_search_parameter',
                                            ) ? (
                                                <div className="search_result_extra_search_parameter">
                                                    {highlight(
                                                        item.extra_search_parameter,
                                                    )}
                                                </div>
                                            ) : null}
                                        </li>
                                    );
                                })
                            ) : (
                                <div className="empty_search">
                                    <div className="empty_search_message">
                                        {oh.translate(
                                            'no_result_' +
                                                this.categories[
                                                    this.state.selected_category
                                                ].name,
                                        )}
                                        <p className="empty_search_message_term">
                                            {this.state.search_term}
                                        </p>
                                    </div>
                                    {this.categories[
                                        this.state.selected_category
                                    ].addNewItem === false ? null : (
                                        <div className="empty_search_action">
                                            <Button
                                                block
                                                filled
                                                label={
                                                    this.categories[
                                                        this.state
                                                            .selected_category
                                                    ].addNewItemLabel
                                                }
                                                onClick={() => {
                                                    this.categories[
                                                        this.state
                                                            .selected_category
                                                    ].addNewItem(
                                                        this.state.search_term,
                                                    );
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>
                            )}
                        </ul>
                    </div>
                ) : null}
            </div>
        );
    }

    render() {
        return (
            <this.container>
                <div
                    className={`search_fade ${
                        this.state.search_term.length > 0 ||
                        this.state.search_focus
                            ? 'active'
                            : ''
                    }`}
                    onClick={() => {
                        this.setState({
                            search_term: '',
                            search_focus: false,
                        });
                    }}
                />
                <Navbar
                    steps
                    fullHeight
                    categories_with_message_count={this.categories}
                    selected_category={this.state.selected_category}
                />
                <div
                    className={`dashboard_layout ${
                        this.categories[this.state.selected_category].layout
                    }`}
                >
                    <div className="dashboard_action">
                        {this.renderStepContent()}
                    </div>
                    {this.renderListedItems()}
                </div>
                <div className="view_fixed_footer">
                    <div className="view_fixed_footer_left">
                        <Button
                            red
                            dark
                            filled
                            label={oh.translate('cancel')}
                            onClick={() => {
                                this.leaveView();
                            }}
                        />
                    </div>
                    <div className="view_fixed_footer_right">
                        <Button
                            disabled={
                                this.state.selected_category < 1 ? true : false
                            }
                            filled
                            label={oh.translate('previous')}
                            onClick={() => {
                                if (this.state.selected_category > 0) {
                                    const next_cat =
                                        this.state.selected_category - 1;
                                    this.categories[next_cat].onClick();
                                }
                            }}
                        />
                        <Button
                            disabled={
                                this.state.selected_category >=
                                this.categories.length - 1
                            }
                            light
                            filled
                            icon="right_arrow"
                            label={oh.translate('next')}
                            onClick={() => {
                                if (
                                    this.state.selected_category <
                                    this.categories.length - 1
                                ) {
                                    const next_cat =
                                        this.state.selected_category + 1;
                                    this.categories[next_cat].onClick();
                                }
                            }}
                        />
                    </div>
                </div>
            </this.container>
        );
    }
}

export default withRouter(withStore(userInputs(CreateView)));



// WEBPACK FOOTER //
// ./src/components/views/CreateView.jsx